import React from 'react';
import NewsFeed from './NewsFeed';
import BislitLogo from './BislitLogo';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="header-top">
          <BislitLogo width={60} height={60} />
          <h1>Bislit News</h1>
        </div>
        <p>Latest headlines from top news sources</p>
      </header>
      <NewsFeed />
      <footer className="App-footer">
        <p>
          Content aggregated from CNN, Fox News, MSNBC, BBC, and Reuters RSS feeds. 
          All articles, images, and trademarks are property of their respective owners. 
          Click any article to read the full story on the original source website.
        </p>
        <p style={{ marginTop: '15px' }}>
          For inquiries regarding content removal, additions, or partnerships, please contact us at{' '}
          <a href="mailto:bislitllc@gmail.com" style={{ color: '#667eea', textDecoration: 'none' }}>
            bislitllc@gmail.com
          </a>
        </p>
      </footer>
    </div>
  );
}

export default App;
